<template>
  <SelectPicker
    ref="selectDestinationReference"
    v-slot="{ item, selected, active }"
    v-model="selected"
    :classes="classes"
    :pre-existing-value="preExistingValue"
    api-value="/api/destinations?search="
    :placeholder-value="placeholderValue"
    :label="label">
    <span
      class="block flex-shrink-0"
      :class="{ 'font-medium': selected, 'font-normal': !selected }">
      <img
        :src="item.image"
        alt=""
        class="flex-shrink-0 rounded-sm h-4 w-6 mr-3">
    </span>

    <span
      class="block mr-3 font-medium "
      :class="{ 'font-gray-900': selected, 'font-normal': !selected, 'italic': item.exists }">
      {{ item.name }}
    </span>

    <span
      class="block truncate mr-3 "
      :class="{ 'font-medium': selected, 'font-light': !selected, 'italic': item.exists }">
      {{ item.area }}
    </span>

    <span
      v-if="item.exists"
      class="block mr-3 italic"
      :class="{ 'text-green-400': active, 'text-green-600': !active }">
      (imported)
    </span>
  </SelectPicker>
</template>

<script setup>
import {
  computed,
  ref, watch,
} from 'vue';
import { CheckIcon } from '@heroicons/vue/24/solid';
import SelectPicker from '@/ComponentsDeprecated/Select/SelectPicker';

const props = defineProps({
  modelValue: {
    type: String,
    required: false,
    default: null,
  },
  classes: {
    type: String,
    required: false,
    default: 'test',
  },
  placeholderValue: {
    type: String,
    required: false,
    default: 'Select Destination',
  },
  label: {
    type: String,
    required: false,
    default: 'Select Destination',
  },
  preExistingValue: {
    type: Array,
    required: false,
    default: [],
  },
});

const emit = defineEmits({ update: (_value) => true });
const selected = ref(props.modelValue);
const selectDestinationReference = ref();
const preExistingValue = computed(() => props.preExistingValue);

function removeSelected() {
  selectDestinationReference.value.resetSelected();
}

defineExpose({ removeSelected });

watch(selected, (newValue) => {
  emit('update:modelValue', newValue);
});

</script>
